import * as React from "react";
import { PropsChecker } from "../../helpers/props-checker/props-checker.mjs";
const GridCollapseContext = React.createContext({
  gridStyle: {},
  initialColumnCount: 0,
  actualColumnCount: 0,
  isOpen: false,
  isTriggerVisible: true
});
const GridCollapseProvider = (props) => {
  return /* @__PURE__ */ React.createElement(PropsChecker, { componentProps: props, componentName: "GridCollapseProvider", defaultValueName: "defaultOpen", valueName: "isOpen", onChangeNames: "onToggle" }, /* @__PURE__ */ React.createElement(GridCollapseProviderInner, { ...props }));
};
const GridCollapseProviderInner = (props) => {
  const { isOpen: outerIsOpen, onToggle, defaultOpen, initialColumnCount } = props;
  const firstUpdate = React.useRef(true);
  const gridRef = React.useRef(null);
  const [gridStyle, setGridStyle] = React.useState({});
  const [innerIsOpen, setInnerIsOpen] = React.useState(defaultOpen || false);
  const [actualColumnCount, setActualColumnCount] = React.useState(0);
  const [initialHeight, setInitialHeight] = React.useState("");
  const [animationState, setAnimationState] = React.useState("closed");
  const isOpen = React.useMemo(() => onToggle && typeof outerIsOpen !== "undefined" ? outerIsOpen : innerIsOpen, [innerIsOpen, outerIsOpen, onToggle]);
  const toggle = React.useCallback(() => {
    const open = !isOpen;
    if (gridRef.current) {
      if (typeof outerIsOpen === "undefined") {
        setInnerIsOpen(open);
      }
      if (onToggle) {
        onToggle(open);
      }
    }
  }, [isOpen, outerIsOpen, onToggle]);
  React.useEffect(() => {
    if (gridRef.current) {
      setInitialHeight("".concat(gridRef.current.scrollHeight, "px"));
    }
  }, [gridRef]);
  React.useLayoutEffect(() => {
    const shouldAnimateonFirstUpdate = !(firstUpdate.current && !isOpen);
    if (gridRef.current && shouldAnimateonFirstUpdate) {
      setAnimationState("animating");
      setGridStyle({
        height: "".concat(gridRef.current.scrollHeight, "px"),
        overflow: "hidden"
      });
    }
    firstUpdate.current = false;
  }, [isOpen, gridRef]);
  React.useLayoutEffect(() => {
    if (animationState === "animating") {
      window.setTimeout(() => {
        if (gridRef.current) {
          setGridStyle({
            height: !isOpen ? initialHeight : "".concat(gridRef.current.scrollHeight, "px"),
            overflow: "hidden"
          });
        }
      });
    }
  }, [animationState, isOpen, gridRef, initialHeight]);
  const setAnimated = () => {
    setAnimationState(isOpen ? "open" : "closed");
    setGridStyle({});
  };
  React.useEffect(() => {
    const scrollHeight = gridRef.current && "".concat(gridRef.current.scrollHeight, "px");
    if (animationState === "closed" && scrollHeight && scrollHeight !== initialHeight) {
      setInitialHeight(scrollHeight);
    }
  }, [animationState, initialHeight]);
  const gridCollapseContextValue = {
    gridRef,
    gridStyle,
    initialColumnCount,
    actualColumnCount,
    isTriggerVisible: actualColumnCount > initialColumnCount,
    isOpen: animationState !== "closed",
    setAnimated,
    setActualColumnCount,
    toggle
  };
  return /* @__PURE__ */ React.createElement(GridCollapseContext.Provider, { value: gridCollapseContextValue }, props.children);
};
export {
  GridCollapseContext,
  GridCollapseProvider
};
